import { useEffect, useState } from "react";
import { Ticket } from "lucide-react";
import { api } from "@/lib/api";
import { PromoCreateForm } from "@/components/PromoCreateForm";
import { PromoRow } from "@/components/PromoRow";

export function PromoStatus() {
  const [list, setList] = useState(null);
  const load = () => api.get("/admin/promos").then((r) => setList(r.data)).catch(() => setList([]));
  useEffect(() => { load(); }, []);
  if (!list) return null;

  return (
    <section data-testid="admin-promo-status" className="mt-6 rounded-3xl bg-[#151C2C] border border-[#00E5A3]/40 p-6 space-y-4">
      <div>
        <p className="text-xs uppercase tracking-wider text-[#00E5A3] flex items-center gap-1.5"><Ticket className="h-4 w-4" /> Promo codes</p>
        <p className="text-xs text-slate-500 mt-1">Each code gives free access with no time limit to the people who use it, until its uses run out or it expires.</p>
      </div>
      <PromoCreateForm onCreated={load} />
      {list.length === 0 && <p data-testid="promo-empty" className="text-sm text-slate-500">No codes yet.</p>}
      <div className="space-y-3">{list.map((p) => <PromoRow key={`${p.code}-${p.max_uses}-${p.expires}-${p.active}`} promo={p} onChanged={load} />)}</div>
    </section>
  );
}
